import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CampaignBrandsRequestDto,
  CampaignBrandsResponseDto,
  CampaignDetailsDto,
  CampaignResponseDto,
  CampaignsRequestDto,
  CampaignsResponseDto,
} from '../dto';

@Injectable()
export class CampaignsApiService {
  private http = inject(HttpClient);

  private route = 'campaigns';

  getCampaignsList(
    filters: CampaignsRequestDto,
  ): Observable<CampaignsResponseDto> {
    return this.http.post<CampaignsResponseDto>(
      `${this.route}/search`,
      filters,
    );
  }

  getAdminCampaignsList(
    filters: CampaignsRequestDto,
  ): Observable<CampaignsResponseDto> {
    return this.http.post<CampaignsResponseDto>(
      `admin/${this.route}/search`,
      filters,
    );
  }

  getOrganizationBrands(
    data: CampaignBrandsRequestDto,
  ): Observable<CampaignBrandsResponseDto> {
    return this.http.post<CampaignBrandsResponseDto>(
      `${this.route}/organization-brands`,
      data,
    );
  }

  getAdminOrganizationBrands(
    organizationId: string,
    data: CampaignBrandsRequestDto,
  ): Observable<CampaignBrandsResponseDto> {
    return this.http.post<CampaignBrandsResponseDto>(
      `admin/${this.route}/organizations/${organizationId}/brands/search`,
      data,
    );
  }

  getSingleCampaign(id: string): Observable<CampaignDetailsDto> {
    return this.http.get<CampaignDetailsDto>(`${this.route}/${id}`);
  }

  getAdminSingleCampaign(id: string): Observable<CampaignDetailsDto> {
    return this.http.get<CampaignDetailsDto>(`admin/${this.route}/${id}`);
  }

  deactivateCampaign(id: string): Observable<void> {
    return this.http.post<void>(`${this.route}/${id}/deactivate`, {});
  }

  reactivateCampaign(id: string): Observable<void> {
    return this.http.post<void>(`${this.route}/${id}/reactivate`, {});
  }

  deactivateAdminCampaign(id: string): Observable<void> {
    return this.http.post<void>(`admin/${this.route}/${id}/deactivate`, {});
  }

  reactivateAdminCampaign(id: string): Observable<void> {
    return this.http.post<void>(`admin/${this.route}/${id}/reactivate`, {});
  }

  createCampaign(formData: FormData): Observable<CampaignResponseDto> {
    return this.http.post<CampaignResponseDto>(this.route, formData);
  }

  createAdminCampaign(formData: FormData): Observable<CampaignResponseDto> {
    return this.http.post<CampaignResponseDto>(`admin/${this.route}`, formData);
  }
}
